import React from "react";
import { Outlet } from "react-router-dom";
import "./outerLayout.css";
import backImage from "../../assets/login/back-ground-image.jpeg";
const OuterLayout = () => {
    return (
        <section className="login-section" style={{ backgroundImage: `url(${backImage})` }}>
            <div className="login-section-overlay">
                <div className="login-container">
                    <Outlet />
                </div>
            </div>
        </section>
    );
};

export default OuterLayout;
